import { AHButton, AHIcon, AHText, Box } from "arkh";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { graphql, useMutation } from "react-relay";
import { UserAdminCreateGroupDeviceAcceptRequestRejectMutation } from "./__generated__/UserAdminCreateGroupDeviceAcceptRequestRejectMutation.graphql";
import { UserAdminCreateGroupDeviceAcceptRequestAcceptMutation } from "./__generated__/UserAdminCreateGroupDeviceAcceptRequestAcceptMutation.graphql";

export function UserAdminCreateGroupDeviceAcceptRequestScreen(props: {
  deviceCode: string;
  nameSuggestion?: string;
  expiresIn?: string;
  onAccept: (deviceId: string) => void;
  onReject: () => void;
}) {
  const [acceptGroupDevice] =
    useMutation<UserAdminCreateGroupDeviceAcceptRequestAcceptMutation>(graphql`
      mutation UserAdminCreateGroupDeviceAcceptRequestAcceptMutation(
        $deviceCode: String!
      ) {
        store {
          acceptSharedMobileDeviceAuthRequest(deviceCode: $deviceCode) {
            id
          }
        }
      }
    `);

  const [rejectGroupDevice] =
    useMutation<UserAdminCreateGroupDeviceAcceptRequestRejectMutation>(graphql`
      mutation UserAdminCreateGroupDeviceAcceptRequestRejectMutation(
        $deviceCode: String!
      ) {
        store {
          rejectSharedMobileDeviceAuthRequest(deviceCode: $deviceCode) {
            deviceCode
          }
        }
      }
    `);
  const onAccept = useCallback(() => {
    acceptGroupDevice({
      variables: { deviceCode: props.deviceCode },
      onCompleted: (data) => {
        props.onAccept(data.store.acceptSharedMobileDeviceAuthRequest.id);
      },
    });
  }, [acceptGroupDevice, props]);
  const onReject = useCallback(() => {
    rejectGroupDevice({
      variables: { deviceCode: props.deviceCode },
    });
    props.onReject();
  }, [props, rejectGroupDevice]);
  return (
    <Box
      space="xlarge"
      color="surface-primary"
      style={{ flex: 1, justifyContent: "flex-start", alignItems: "center" }}
    >
      <AHIcon type="scan" size="large" color="darkerText" />
      <AHText type="title" spaceTop="large" spaceBottom="small">
        <FormattedMessage
          defaultMessage="Accept authentication request"
          description="Title for the shared device scan screen"
        />
      </AHText>
      <AHText type="subtitle" color="text-secondary" spaceBottom="xlarge">
        <FormattedMessage
          defaultMessage={`A device with the name {nameSuggestion} has requested to log in.`}
          description="Description for the shared device scan screen"
          values={{
            nameSuggestion: props.nameSuggestion,
          }}
        />
      </AHText>

      <Box
        shadow="strong"
        cornerRadius="large"
        color="surface-primary"
        space="large"
      >
        <AHText type="title">{props.nameSuggestion}</AHText>
      </Box>
      <Box
        space="large"
        style={{
          flexDirection: "row",
          width: "100%",
          justifyContent: "center",
        }}
        spaceVertical="xlarge"
        gap="medium"
      >
        <AHButton
          title={
            <FormattedMessage
              defaultMessage="Reject"
              description="UserAdminCreateGroupDeviceAcceptRequestScreen reject button"
            />
          }
          themeType="default"
          onPress={onReject}
        />
        <AHButton
          title={
            <FormattedMessage
              defaultMessage="Accept"
              description="UserAdminCreateGroupDeviceAcceptRequestScreen accept button"
            />
          }
          themeType="primary"
          onPress={onAccept}
        />
      </Box>
    </Box>
  );
}
